import React from 'react';
import './styles.css';

const Spinner: React.FC = () => <div className="spinner" />;

export default Spinner;
